{
  "name": "fresh-ai-webapp",
  "version": "0.1.261",
  "scripts": {
    "ng": "ng",
    "prebuild": "node ./version/create-version.js",
    "start:local": "node ./version/create-version.js && ng serve --configuration local --proxy-config proxy.conf.json",
    "start:qa": "ng serve --configuration qa",
    "build:local": "ng build --configuration local",
    "build:dev": "node ./version/create-version.js && ng build --configuration dev",
    "build:dev-cloud-stt": "ng build --configuration dev-cloud-stt",
    "build:qa": "node ./version/create-version.js && ng build --configuration qa",
    "build:staging": "node ./version/create-version.js && ng build --configuration staging",
    "build:staging-exp-b": "ng build --configuration staging-exp-b",
    "build:prod": "node ./version/create-version.js && ng build --configuration prod",
    "clean": "rm -rf node_modules/; rm -rf dist/",
    "formatter": "prettier 'src/**/*.{ts,html,scss,md}' *.md  *.yml tsconfig.app.json angular.json package.json --write",
    "formatter:windows": "prettier .\\src\\**\\*.{ts,html,scss,md} *.md *.yml tsconfig.app.json angular.json package.json --write",
    "formatter:ci": "prettier 'src/**/*.{ts,html,scss,md}' *.md tsconfig.app.json angular.json package.json --check",
    "formatter:pre-commit": "prettier --check",
    "linter": "eslint --max-warnings 0",
    "linter:fix": "eslint --max-warnings 0 --fix",
    "linter:pre-commit": "eslint --max-warnings 0",
    "style-linter": "stylelint '**/*.scss'",
    "style-linter:pre-commit": "stylelint '**/*.scss'",
    "prepare": "husky install",
    "test": "ng test --browsers=ChromeHeadless --code-coverage --main ./src/test.ts --watch=false",
    "test:debug": "ng test --browsers=Chrome --code-coverage --watch=true --main ./src/test.ts",
    "test:headless": "ng test --browsers=ChromeHeadlessNoSandbox --watch=false --main ./src/test.ts",
    "patch": "npm version patch && git add package.json && git add package-lock.json && git commit --amend --no-edit",
    "patch:push": "npm version patch && git add package.json && git add package-lock.json && git commit --amend --no-edit && git push"
  },
  "private": true,
  "husky": {
    "hooks": {
      "pre-push": "npm version patch"
    }
  },
  "dependencies": {
    "@angular/animations": "~20.3.17",
    "@angular/common": "~20.3.17",
    "@angular/compiler": "~20.3.17",
    "@angular/core": "~20.3.17",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "~20.3.17",
    "@angular/platform-browser": "~20.3.17",
    "@angular/platform-browser-dynamic": "~20.3.17",
    "@angular/router": "~20.3.17",
    "@angular/service-worker": "^20.3.17",
    "@openfeature/flipt-web-provider": "^0.1.6",
    "@openfeature/web-sdk": "^1.10.0",
    "@popperjs/core": "~2.11.8",
    "@types/uuid": "~8.3.4",
    "angularx-qrcode": "~20.0.0",
    "bootstrap": "~5.3.8",
    "cors": "^2.8.5",
    "firebase": "^12.11.0",
    "launchdarkly-js-client-sdk": "^3.4.0",
    "lottie-web": "~5.13.0",
    "moment-timezone": "^0.5.45",
    "ngx-lottie": "~20.0.0",
    "ngx-toastr": "~19.0.0",
    "recordrtc": "^5.6.2",
    "rxjs": "~7.8.1",
    "socket.io-client": "~4.8.3",
    "uuid": "~8.3.2",
    "wavefile": "^11.0.0",
    "web-vitals": "^5.1.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.19",
    "@angular/cli": "^20.3.19",
    "@angular/compiler-cli": "~20.3.17",
    "@types/jasmine": "~4.6.4",
    "@types/moment": "^2.11.29",
    "@types/node": ">=20.0.0",
    "@types/recordrtc": "^5.6.14",
    "@typescript-eslint/eslint-plugin": "^8.57.0",
    "@typescript-eslint/parser": "^8.57.0",
    "colors": "^1.4.0",
    "eslint": "~10.0.3",
    "eslint-plugin-html": "^8.1.4",
    "globals": "^17.4.0",
    "husky": "~8.0.3",
    "jasmine-core": "~4.6.1",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "karma-spec-reporter": "^0.0.36",
    "lint-staged": "~13.3.0",
    "ng-mocks": "^14.13.0",
    "prettier": "~2.8.8",
    "stylelint": "~14.16.1",
    "stylelint-config-idiomatic-order": "~10.0.0",
    "stylelint-config-sass-guidelines": "~9.0.1",
    "stylelint-config-standard": "~27.0.0",
    "typescript": "~5.8.3"
  },
  "prettier": {
    "semi": true,
    "trailingComma": "all",
    "singleQuote": true,
    "printWidth": 120
  },
  "lint-staged": {
    "*.{ts,js}": [
      "npm run linter:pre-commit",
      "npm run formatter:pre-commit"
    ],
    "*.{css,less,sass,scss,sss}": [
      "npm run style-linter:pre-commit",
      "npm run formatter:pre-commit"
    ],
    "*.{md,MD,yaml,yml}": [
      "npm run formatter:pre-commit"
    ]
  },
  "workspaces": [
    "functions"
  ],
  "engines": {
    "node": ">=26.12.1",
    "npm": ">=10.0.0"
  }
}
